import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, MapPin } from 'lucide-react';
import { businessInfo } from '../mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'About', href: '/about' },
    { name: 'Reviews', href: '/reviews' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-neutral-900/95 backdrop-blur-md border-b border-neutral-800">
      {/* Top bar with contact info */}
      <div className="bg-black border-b border-neutral-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-2 text-sm">
            <div className="flex items-center gap-4 text-gray-400">
              <span className="hidden sm:flex items-center gap-1">
                <MapPin className="w-4 h-4" />
                {businessInfo.address}
              </span>
              <span className="flex items-center gap-1 text-white">
                Open Daily • Closes 2:00 AM
              </span>
            </div>
            <a 
              href={`tel:${businessInfo.phone}`}
              className="flex items-center gap-2 text-white hover:text-gray-300 transition-colors font-semibold"
            >
              <Phone className="w-4 h-4" />
              {businessInfo.phone}
            </a>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-white to-teal-500 rounded-lg flex items-center justify-center">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Evolution</h1>
              <p className="text-xs text-gray-400">Cell Phone Repairs</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.href)
                    ? 'bg-white text-white'
                    : 'text-gray-300 hover:text-white hover:bg-neutral-800'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a
              href={`tel:${businessInfo.phone}`}
              className="px-6 py-2.5 bg-white hover:bg-gray-100 text-black font-bold text-white font-semibold rounded-lg transition-colors shadow-lg shadow-white/20"
            >
              Call Now
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-300 hover:text-white"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-neutral-800 bg-neutral-900">
          <nav className="px-4 py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.href)
                    ? 'bg-white text-white'
                    : 'text-gray-300 hover:bg-neutral-800 hover:text-white'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a
              href={`tel:${businessInfo.phone}`}
              className="block w-full px-4 py-3 bg-white hover:bg-gray-100 text-black font-semibold rounded-lg text-center transition-colors"
            >
              Call Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
